import React, { useContext } from 'react';
import { ThemeContext } from '../ThemeContext';

const TopAppBar = ({ currentView, setView }) => {
  const { isDark, setIsDark } = useContext(ThemeContext);

  return (
    <header className="fixed top-0 w-full z-50 bg-surface-container/90 backdrop-blur-xl border-b border-outline-variant/20 shadow-sm transition-colors duration-300">
      <nav className="flex justify-between items-center px-4 md:px-8 h-14 md:h-16 w-full max-w-none">
        <div 
          className="text-lg md:text-xl font-black tracking-tighter text-on-surface uppercase cursor-pointer"
          onClick={() => setView('landing')}
        >
          Nomit Verma
        </div>
        
        {currentView === 'gui' && (
          <div className="hidden md:flex space-x-6 lg:space-x-8 font-['Inter'] font-bold tracking-tight uppercase text-sm">
            <a className="text-on-surface border-b border-on-surface pb-1 hover:text-primary transition-colors" href="#about">About</a>
            <a className="text-on-surface-variant hover:text-on-surface transition-colors" href="#experience">Experience</a>
            <a className="text-on-surface-variant hover:text-on-surface transition-colors" href="#skills">Skills</a>
            <a className="text-on-surface-variant hover:text-on-surface transition-colors" href="#projects">Projects</a>
            <a className="text-on-surface-variant hover:text-on-surface transition-colors" href="#contact">Contact</a>
          </div>
        )}

        <div className="flex items-center space-x-2 md:space-x-4">
          <button 
            onClick={() => setIsDark(!isDark)}
            className="hover:bg-on-surface/5 p-2 rounded transition-all duration-200 active:scale-95 text-on-surface"
            aria-label="Toggle dark mode"
          >
            <span className="material-symbols-outlined">{isDark ? 'light_mode' : 'dark_mode'}</span>
          </button>
          
          <a className="hidden lg:flex items-center space-x-2 px-3 py-1 hover:bg-on-surface/5 rounded transition-all duration-200 group text-on-surface" href="/assets/nomit_verma_resume_online.pdf" target="_blank" rel="noreferrer">
            <span className="material-symbols-outlined text-[20px] group-hover:scale-110 transition-transform">download</span>
            <span className="font-['Inter'] font-bold tracking-tight uppercase text-xs">Resume</span>
          </a>
          
          <div className="hidden lg:block h-6 w-[1px] bg-outline-variant/30"></div>
          
          {currentView !== 'terminal' && (
             <button 
               onClick={() => setView('terminal')}
               className="hidden lg:block font-['Inter'] font-bold tracking-tight uppercase text-xs text-on-surface-variant hover:text-on-surface transition-colors"
             >
               Terminal
             </button>
          )}
          {currentView === 'terminal' && (
             <button 
               onClick={() => setView('gui')}
               className="hidden lg:block font-['Inter'] font-bold tracking-tight uppercase text-xs text-on-surface-variant hover:text-on-surface transition-colors"
             >
               Exit Terminal
             </button>
          )}
        </div>
      </nav>
    </header>
  );
};

export default TopAppBar;
